import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-ipad-center-4",
  "use": "icon-ipad-center-4-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-ipad-center-4\"><path d=\"M128 704v192h768v-192h64v256H64v-256h64z m416-576v518.4l236.8-230.4 51.2 44.8-281.6 268.8-38.4 38.4-307.2-307.2 44.8-44.8 230.4 230.4V128h64z\" p-id=\"18742\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol